import React, { useState, useEffect } from 'react';
import axios from 'axios';

export default function CoverImages() {
  const [images, setImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [uploading, setUploading] = useState(false);

  const fetchImages = async () => {
    try {
      const res = await axios.get('/speeddate/api/cover-images');
      setImages(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { fetchImages(); }, []);

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('image', file);
      await axios.post('/speeddate/api/cover-images', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      fetchImages();
      window.Swal.fire({ title: 'Caricata!', icon: 'success', timer: 1500, showConfirm: false, toast: true, position: 'top-end' });
    } catch (err) {
      window.Swal.fire('Errore', err.response?.data?.error || 'Errore caricamento', 'error');
    } finally {
      setUploading(false);
      e.target.value = '';
    }
  };

  const handleDelete = async (filename) => {
    window.Swal.fire({
      title: 'Eliminare immagine?',
      text: 'Questa operazione non può essere annullata.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Elimina',
      cancelButtonText: 'Annulla',
      confirmButtonColor: '#d33'
    }).then(async (res) => {
      if (res.isConfirmed) {
        try {
          await axios.delete(`/speeddate/api/cover-images/${filename}`);
          fetchImages();
          window.Swal.fire({ title: 'Eliminata!', icon: 'success', timer: 1500, showConfirm: false, toast: true, position: 'top-end' });
        } catch (err) {
          window.Swal.fire('Errore', err.response?.data?.error || 'Errore', 'error');
        }
      }
    });
  };

  const copyUrl = (url) => {
    const fullUrl = `https://app.solteros.it${url}`;
    navigator.clipboard.writeText(fullUrl).then(() => {
      window.Swal.fire({ title: 'URL copiato!', icon: 'success', timer: 1200, showConfirm: false, toast: true, position: 'top-end' });
    }).catch(() => {
      // Fallback: select the text
      window.prompt('Copia questo URL:', fullUrl);
    });
  };

  if (loading) return <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>;

  return (
    <div className="wow fadeIn">
      <div className="card border-0 shadow-sm">
        <div className="card-header bg-transparent border-0 pt-4 px-4 d-flex justify-content-between align-items-center">
          <h4 className="mb-0 fw-bold"><i className="fas fa-images text-primary me-2"></i>Immagini di Copertina</h4>
          <label className="btn btn-primary btn-sm rounded-pill px-3 shadow-sm" style={{ cursor: uploading ? 'not-allowed' : 'pointer' }}>
            <i className="fas fa-upload me-1"></i> {uploading ? 'Caricamento...' : 'Carica Immagine'}
            <input type="file" accept="image/*" className="d-none" onChange={handleUpload} disabled={uploading} />
          </label>
        </div>
        <div className="card-body px-4">
          {images.length === 0 ? (
            <div className="text-center py-5 text-muted">
              <i className="fas fa-image fa-3x mb-3 opacity-25"></i>
              <p className="mb-0 fs-5">Nessuna immagine caricata</p>
              <p className="small">Clicca su "Carica Immagine" per iniziare</p>
            </div>
          ) : (
            <div className="row g-4">
              {images.map(img => (
                <div key={img.filename} className="col-lg-4 col-md-6 col-sm-12">
                  <div className="card border-0 shadow-sm h-100">
                    <div className="position-relative" style={{ paddingTop: '56.25%', overflow: 'hidden' }}>
                      <img
                        src={img.url}
                        alt={img.filename}
                        className="position-absolute top-0 start-0 w-100 h-100"
                        style={{ objectFit: 'cover', cursor: 'pointer' }}
                        onClick={() => copyUrl(img.url)}
                        title="Clicca per copiare URL"
                      />
                    </div>
                    <div className="card-body p-3 d-flex justify-content-between align-items-center">
                      <div className="small text-muted text-truncate me-2" style={{ flex: 1 }}>
                        {img.filename}
                        <br />
                        <span className="smaller">{new Date(img.uploadedAt).toLocaleDateString('it-IT')}</span>
                      </div>
                      <div className="d-flex gap-1">
                        <button className="btn btn-sm btn-outline-primary rounded-pill" onClick={() => copyUrl(img.url)} title="Copia URL">
                          <i className="fas fa-link"></i>
                        </button>
                        <button className="btn btn-sm btn-outline-danger rounded-pill" onClick={() => handleDelete(img.filename)} title="Elimina">
                          <i className="fas fa-trash-alt"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}